import type { LeadBulkActionKind } from "api/lead";

export const LEAD_BULK_ACTION_LABELS: Record<
  LeadBulkActionKind,
  { progress: string; done: string }
> = {
  assign: { progress: "Assigning", done: "assigned" },
  change_stage: { progress: "Changing stage for", done: "moved" },
  delete: { progress: "Deleting", done: "deleted" }
};
